import { GoalFilterDocument } from '@griply/types';
import {
  getGoalListControlDocument,
  getGoalListEntityUpdate,
} from '@griply/utils';
import { useUpdateLifeArea } from 'features/life-areas';
import React, { useMemo } from 'react';
import { GoalListFilterButton } from 'shared/components/connected/goal-list-filter-button';
import { LifeArea } from 'shared/types/life-area';

export type LifeAreaGoalsFilterButtonProps = {
  lifeArea: LifeArea;
};

export const LifeAreaGoalsFilterButton: React.FC<
  LifeAreaGoalsFilterButtonProps
> = ({ lifeArea }) => {
  const { submit: updateLifeArea } = useUpdateLifeArea();

  const filterDocument = useMemo(
    () =>
      getGoalListControlDocument({
        goalFilterDocument: lifeArea.goalFilterDocument,
        goalSortingMode: lifeArea.goalSortingMode,
      }),
    [lifeArea.goalFilterDocument, lifeArea.goalSortingMode],
  );

  const persist = (next: Partial<GoalFilterDocument>) => {
    const update = getGoalListEntityUpdate({
      ...filterDocument,
      ...next,
    });
    updateLifeArea({ id: lifeArea.id, ...update });
  };

  const handleReset = () => persist({ filters: null });

  return (
    <GoalListFilterButton
      filterDocument={filterDocument}
      hideLifeArea
      onUpdate={persist}
      onReset={handleReset}
    />
  );
};
